export enum PhitoNotificationType {
    UNDEFINED = 'UNDEFINED',
    CREATED = 'CREATED',
    UPDATED = 'UPDATED',
    DELETED = 'DELETED',
    INFORMATION = 'INFORMATION',
    WARNING = 'WARNING',
    ERROR = 'ERROR',
    CRITICAL = 'CRITICAL',
}
